import { FormatDateEnum } from '../enums/FormatDateEnum';

export const utilService = {
  transformObjectKeys,
  formatDateTime,
  calculateDateDifference,
  calculateDurationHHMMSS,
  validateCSharpTimeSpan,
  generateRandomWord,
  isEmptyList,
  getFixed2DigitsDouble,
  getFixedDigitsDouble,
  isValidUrl
}

window.utilService = utilService;

function transformObjectKeys(obj) {
  const transformedObj = {};
  for (let key in obj) {
    // Capitalize the first letter of the property name
    const transformedKey = key.charAt(0).toUpperCase() + key.slice(1);
    transformedObj[transformedKey] = obj[key];
  }
  return transformedObj;
}

// Date Methods

function formatDateTime(dateTime, format) {
  let formatedValue = '';
  const date = new Date(dateTime);

  if (format === FormatDateEnum.Date || format === FormatDateEnum.DateTime) {
    const year = String(date.getFullYear());
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    formatedValue += `${day}/${month}/${year}`;
  }

  if (format === FormatDateEnum.Time || format === FormatDateEnum.dateTime) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    formatedValue += `${hours}:${minutes}`;
  }
  return formatedValue;
}

function calculateDateDifference(start, end) {

  if (start && end) {

    let dateSegments = end.split("/");
    let modifiedDateString = `${dateSegments[1]}/${dateSegments[0]}/${dateSegments[2]}`;
    const endDate = new Date(modifiedDateString);

    dateSegments = start.split("/");
    modifiedDateString = `${dateSegments[1]}/${dateSegments[0]}/${dateSegments[2]}`;
    const startDate = new Date(modifiedDateString);
    const differenceInMilliseconds = endDate.getTime() - startDate.getTime();

    const hours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000);

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  return '';
}

/**
 * Safely calculates a duration string in HH:mm:ss.
 * Accepts Date objects, ISO strings, or parseable date strings.
 * Returns empty string when dates are missing/invalid.
 */
function calculateDurationHHMMSS(start, end) {
  if (!start || !end) return '';

  const startDate = start instanceof Date ? start : new Date(start);
  const endDate = end instanceof Date ? end : new Date(end);

  const startMs = startDate.getTime();
  const endMs = endDate.getTime();
  if (Number.isNaN(startMs) || Number.isNaN(endMs)) return '';

  const diffMs = endMs - startMs;
  if (Number.isNaN(diffMs)) return '';

  // Keep UX stable even if clocks / ordering are off
  const absMs = Math.abs(diffMs);

  const hours = Math.floor(absMs / (1000 * 60 * 60));
  const minutes = Math.floor((absMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((absMs % (1000 * 60)) / 1000);

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

function validateCSharpTimeSpan(time) {
  var timeParts = time.split(':');

  if (timeParts.length < 3) {
    time += ':00'
  }

  return time;
}

function generateRandomWord() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomWord = '';
  for (let i = 0; i < 5; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomWord += characters.charAt(randomIndex);
  }
  return randomWord;
}

function isEmptyList(list) {
  return !list || list.length === 0
}

function getFixed2DigitsDouble(num) {
  return Math.floor(num * 100) / 100;
}

function getFixedDigitsDouble(number, digits = 2) {
  if (typeof number !== 'number' || typeof digits !== 'number') {
    return 0.0;
  }
  if (digits < 0) {
    return 0.0;
  }

  let numberString = number.toString();
  if (numberString) {
    const decimalIndex = numberString.indexOf('.');
    if (decimalIndex !== -1 && decimalIndex + digits + 1 < numberString.length) {
      numberString = numberString.substring(0, decimalIndex + digits + 1);
    }
    const parsedNumber = parseFloat(numberString);
    return isNaN(parsedNumber) ? 0.0 : parsedNumber;
  } else {
    return 0.0;
  }
}

function isValidUrl(text) {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i' // fragment locator
  );
  return !!urlPattern.test(text);
};

